import React from 'react';
import logo from '../assets/img/new_logo.png';

interface InfoPanelProps{
  deviceType: string;
}

const InfoPanel = (props: InfoPanelProps): JSX.Element => (
  <div className={`info-panel device-${props.deviceType}`}>
    <div className={'img-container'}>
        <img src={logo} alt="" />
    </div>
    <span>When storms and extreme weather hit, BGE is dedicated to safely restoring service to our customers as quickly as possible.
    BGE personnel will work around-the-clock until all repairs are made and service is restored. </span>
    <span>For more information on our Storm Restoration Process</span>
    <a href="https://www.bge.com/outages/preparing-for-an-outage/our-restoration-process">click here</a>
  </div>
);

export default InfoPanel;
